"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Link_component_exports = {};
__export(Link_component_exports, {
  Link: () => Link,
  generateLinkStyles: () => generateLinkStyles
});
module.exports = __toCommonJS(Link_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"));
var import_clsx = __toESM(require("clsx"));
function generateLinkStyles({
  size = "medium",
  variant = "inline",
  className,
  iconPosition
}) {
  return (0, import_clsx.default)(
    "flex items-center justify-center w-fit font-family-body",
    `${iconPosition === "right" && "flex-row-reverse"}`,
    `${size === "medium" ? "gmui-font-link-standalone-medium gmui-themed-font-weight-link-standalone-medium" : "gmui-font-link-standalone-small gmui-themed-font-weight-link-standalone-small"}`,
    `${variant === "inline" ? "gmui-link-text-underline" : "gmui-link-text-no-underline"}`,
    `${variant === "inline" ? "hover:no-underline" : "hover:underline"}`,
    "gmui-link-text",
    className
  );
}
const Link = (0, import_react.forwardRef)(
  (_a, ref) => {
    var _b = _a, {
      size = "medium",
      className,
      variant = "standalone",
      children,
      icon,
      iconPosition
    } = _b, props = __objRest(_b, [
      "size",
      "className",
      "variant",
      "children",
      "icon",
      "iconPosition"
    ]);
    const styles = generateLinkStyles({ size, variant, className, iconPosition });
    const IconLink = () => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "flex h-[20px] w-[20px] items-center justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "flex w-s items-center justify-center", children: import_react.default.cloneElement(icon, {
        className: (0, import_clsx.default)(["link-icon", className])
      }) }) }) });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("a", __spreadProps(__spreadValues({ ref, className: styles }, props), { children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconLink, {}),
      children
    ] }));
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Link,
  generateLinkStyles
});
//# sourceMappingURL=Link.component.js.map